import { UseQueryOptions } from 'react-query';
import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import useQuery from 'hooks/useQuery';
import QueryKeys from './keys';
import { WhatsApp } from 'domains/content/types';

const useWhatsApp = (whatsAppTemplateId: string | null, reactQueryOptions?: UseQueryOptions<WhatsApp, Error>) =>
    useQuery<WhatsApp>(
        QueryKeys.WHATSAPP_TEMPLATE_ID(whatsAppTemplateId || ''),
        whatsAppTemplateId ? new PathWithID(CuredApiPaths.WHATSAPP_TEMPLATES, Number(whatsAppTemplateId)).url : '',
        reactQueryOptions
    );

export default useWhatsApp;
